import React from 'react';
import { Text, Icon } from 'porosys-ui';
import './styles.scss';

const ListHeader = props => {
    const { handleOpenForm, listTitle } = props;

    return (
        <div className="list_header">
            <div className="flex space-between">
                <Text variant="h4">{listTitle}</Text>
                {handleOpenForm ? (
                    <Icon classes={{ root: 'add-btn' }} onClick={handleOpenForm} name="plusSquare" />
                ) : (
                    ''
                )}
            </div>
            <hr />
        </div>
    );
};

export default ListHeader;
